import { lighten } from '@mui/material/styles';
import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        '&.disabled': {
            color: lighten(theme.colors.primary.main, 0.5),
            pointerEvents: 'none',
        },
    },
}));
//# sourceMappingURL=Link.styles.js.map